import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core';
import { SummaryService } from '../services/summary.service';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-advanced-table-header',
  templateUrl: './advanced-table-header.component.html',
  styleUrls: ['./advanced-table-header.component.css']
})

export class AdvancedTableHeaderComponent implements OnInit, IHeaderAngularComp {
  
  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;

  public params: IHeaderParams;
  public sorted: string;
  public filter: string;
  private elementRef: ElementRef;
  searchTextChanged = new Subject<string>();

  constructor(elementRef: ElementRef, private summaryService: SummaryService, private contextMenuService: ContextMenuService) {
    this.elementRef = elementRef;

    this.summaryService.sortChanged$.subscribe(result => {
      if (result){
        if (this.params){
          var colDef = this.params.column.getColDef();
          var currentColDef = result.column.getColDef();
          if (colDef && currentColDef){
            if (colDef.field != currentColDef.field){
              this.sorted = '';
              this.params.column.setSort(null);
            }
          }
        }
      }
    })
  }

  ngOnInit() {
    this.searchTextChanged.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap((value) => {
        // this.isPropertyLoading = true
      }
      )
    ).subscribe(result => {
      this.summaryService.setFilter(this.params);
    })

  }

  agInit(params: any): void {
    this.params = params;
    if (this.params.column.getSort()){
      if (this.params.column.isSortAscending()) {
        this.sorted = 'asc'
      } else if (this.params.column.isSortDescending()) {
          this.sorted = 'desc'
      } else {
          this.sorted = ''
      }
    }
  }

  onMenuClick() {
    this.params.showColumnMenu(this.querySelector('.customHeaderMenuButton'));
  }

  onSortRequested(order, event) {
    if (this.params.column.getSort()){
      this.handleSorting();
    }
    else{
      this.sorted = "asc";
    }
    this.params.column.setSort(this.sorted, event.shiftKey);
    
    //its time
    this.summaryService.setSort(this.params);
  };

  handleSorting() {
    if (this.params.column.isSortAscending()) {
        this.sorted = 'desc'
    } else if (this.params.column.isSortDescending()) {
        this.sorted = 'asc'
    } else {
        this.sorted = ''
    }
  };

  public onContextMenu($event): void {
    if($event.button == 0){
      this.contextMenuService.show.next({
        contextMenu: this.basicMenu,
        event: $event,
        item: ''
      });
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  onCloseContextMenu() {
    //console.log('close menu')
  }

  input(keyword){
    this.searchTextChanged.next(keyword);
  }

  private querySelector(selector: string) {
    return <HTMLElement>this.elementRef.nativeElement.querySelector('.customHeaderMenuButton', selector);
  }
}